import React from 'react';

import { CodeMessage } from './styles';
import useTranslate from '@src/i18n/useTranslate';
import usePhoneVerification from '@src/features/customers/auth/phone-verification/hooks/usePhoneVerification';

interface PhoneVerifactionMessageProps extends Omit<React.HTMLAttributes<HTMLParagraphElement>, 'children'> {
  loadingMessage?: string;
  codeExpiresMessage?: string;
}

const Message = ({ loadingMessage, codeExpiresMessage }: PhoneVerifactionMessageProps) => {
  const { i18n } = useTranslate();
  const { loading, isOver, minutes, seconds } = usePhoneVerification();

  const getFormattedTime = (time: number) => {
    return time.toLocaleString('pt-BR', { minimumIntegerDigits: 2, useGrouping: false });
  };

  if (loading) {
    return <CodeMessage>{loadingMessage ?? i18n('direct_link_phone_verification_form_sending_code')}</CodeMessage>;
  }

  if (!isOver) {
    return (
      <CodeMessage>
        {codeExpiresMessage ?? (
          <>
            {i18n('direct_link_phone_verification_form_code_expires')} {getFormattedTime(minutes)}:
            {getFormattedTime(seconds)}
          </>
        )}
      </CodeMessage>
    );
  }

  return null;
};

export default Message;
